import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LoginView from './views/Login';
import Inicio from './views/Inicio';
import { AuthProvider } from './contexts/AuthContext';
import { LoadingProvider } from './contexts/LoadingContext';

const PrivateRoute = ({ element }: any) => {
  return element;
};


const App = () => {
  return (
    <AuthProvider>
      <LoadingProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginView />} />
            <Route path="*" element={<PrivateRoute element={<Inicio />} />} />
          </Routes>
        </BrowserRouter>
      </LoadingProvider>
    </AuthProvider>
  );
};

export default App;
